<div class="dashboard-wrapper">
    <header class="dashboard-header">
        <h2>{{ "dashboard_welcome" | transloco }}</h2>
        <p class="mat-body-1">{{ "dashboard_subtitle" | transloco }}</p>
    </header>

    <div class="dashboard-grid">
        @for (group of filteredDashboardGroups(); track group.titleKey) {
        <mat-card class="group-card">
            <mat-card-header>
                <mat-icon
                    mat-card-avatar
                    class="group-icon"
                >{{ group.icon }}</mat-icon>
                <mat-card-title>{{ group.titleKey | transloco }}</mat-card-title>
            </mat-card-header>

            <mat-card-content class="links-container">
                @for (item of group.items; track item.route.join('/')) {
                <a
                    mat-stroked-button
                    [routerLink]="item.route"
                    class="dashboard-action-btn"
                >
                    <mat-icon>{{ item.icon }}</mat-icon>
                    <span>{{ item.labelKey | transloco }}</span>
                </a>
                }
            </mat-card-content>
        </mat-card>
        }
    </div>
</div>